import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import {useTranslation} from "ni18n";
import React from "react";

import {Btn} from "../V5Comp";

const Hero = () => {
  const i18n = useTranslation();

  return (
    <div className="pos-r dg ph4 pt24-md ph0-md pb4-md bg-darkerBlue bgcov bgpc minh180 minh0-md">
      <NextImage
        src="/covidReady3/hero"
        layout="fill"
        priority
        objectFit="cover"
        className="h100p obfc"
        alt=""
      />
      <div className="pos-r maxw75 w100p ph4 ma dg aic h100p">
        <div>
          <h1 className="white mt4 maxw30">{i18n.t("Get your workforce COVID Ready")}</h1>
          <h4 className="white mt0 fs20 maxw36">
            {i18n.t(
              "Keep your employees safe with COVID-19 testing, tracking, vaccines, medical protocols and more.",
            )}
          </h4>
          <Btn
            href="#signup"
            color={colors.gray800}
            bg={colors.gray50}
            hoverBg={colors.gray200}
            className="mt8"
          >
            {i18n.t("Talk to Our Team")}
          </Btn>
        </div>
      </div>
    </div>
  );
};

export default Hero;
